import { CSSObject } from '@chakra-ui/react';

export const ExoticResultedWrapper: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  px: '2',
  border: 'none',
  bg: 'zeta.400',
  borderRadius: 'base',
  flex: '1',
  boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.15)',
  color: 'alpha.800',
  fontWeight: 'medium',
};

export const TypeItem: CSSObject = {
  color: 'alpha.800',
  fontWeight: 'bold',
  fontSize: 'xs',
};

export const ResultRowWrapper: CSSObject = {
  border: 'none',
  borderRadius: ['base', null, 'md'],
  mb: '1',
  p: '1.5',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  bg: 'whiteAlpha.600',
  _last: {
    mb: '2',
  },
};

export const ResultRowExoticWrapper: CSSObject = {
  fontSize: 'sm',
};

export const ResultRowExoticRow: CSSObject = {
  color: 'alpha.700',
  fontWeight: '700',
};
